import React from 'react';
import SurveyChartUtils from '../shared/SurveyChartUtils';
import FormMuiInputNumber from '@shared/components/form/FormMuiInputNumber';
import MuiInputNumber from '@shared/components/MuiInputNumber';
import AutoCalculatedSurveyMap from '../shared/AutoCalculatedSurveyMap';

/**
 * @typedef {object} SurveyYearlyValueRecordSurveyResultValues
 * @property {number} Year
 * @property {number} [Value]
 */

/**
 * @typedef {object} SurveyYearlyValueRecord
 * @property {SurveyYearlyValueRecordSurveyResultValues[]} SurveyResultValues
 * @property {string} Label
 * @property {boolean} [IsAutoCalculated]
 * @property {number} [QuestionId]
 * @property {number} [Presentation]
 */

/**
 * @typedef {object} SurveyYearlyValueProps
 * @property {number} year
 * @property {SurveyYearlyValueRecord} record
 * @property {boolean} [isEditMode]
 * @property {Array<*>} allResults
 * @property {number} [questionIndex]
 */

/**
 * @param {SurveyYearlyValueProps} props
 */
const SurveyYearlyValue = props => {
  const { year, record, isEditMode, allResults, questionIndex } = props;
  const surveyResultValueIndex = record.SurveyResultValues.findIndex(cd => cd.Year === year);
  const surveyResultIndex = allResults.findIndex(result => result.Label === record.Label);
  const value = record.IsAutoCalculated
    ? AutoCalculatedSurveyMap[record.QuestionId].getValue({ year, allResults })
    : record.SurveyResultValues[surveyResultValueIndex]?.Value;

  if (!isEditMode) {
    return (
      <span className='survey-results__span'>
        {SurveyChartUtils.formatSurveyValue({ value, presentation: record.Presentation })}
      </span>
    );
  }

  if (record.IsAutoCalculated) {
    return (
      <MuiInputNumber
        value={SurveyChartUtils.formatSurveyValue({
          value,
          presentation: record.Presentation
        })}
        allowSignedNumber={true}
        disabled={true}
      />
    );
  }

  return (
    <FormMuiInputNumber
      name={
        `questions.${questionIndex}.SurveyResults.${surveyResultIndex}.` +
        `SurveyResultValues.${surveyResultValueIndex}.Value`
      }
      placeholder='-'
    />
  );
};

export default SurveyYearlyValue;
